import { useSearchParams } from "react-router-dom";
import { CopyCode } from "../../components/CopyCode/CopyCode";
import { HelpPopover } from "../../components/ui/help-popover";
import { ArenaLogo } from "@/components/common/ArenaLogo";
import LogoBg from "../../assets/logo-bg.png";


export default function Reauthorize() {
  const [searchParams] = useSearchParams();
  const authUrl = searchParams.get("authUrl");

  if (!authUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-foreground mb-2">
            Invalid Authorization URL
          </h1>
          <p className="text-muted-foreground">
            No authorization URL was provided. Please try again with a valid
            URL.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className=" flex items-center justify-center h-full m-auto flex items-center">
        <div
        className="absolute inset-0 -z-50 w-full bg-cover lg:bg-[size:95%_auto] bg-no-repeat bg-[linear-gradient(50deg,rgba(255,255,255,0),rgba(255,255,255,1)),radial-gradient(371.56%_195.04%_at_20.94%_47.24%,rgba(255,255,255,0)_0%,rgba(255,255,255,1)_41.2%),var(--logo-bg-image)]"
        style={{
          ["--logo-bg-image" as string]: `url(${LogoBg})`,
        }}
      ></div>
      <div className="max-w-3xl w-full mx-4">

        <div className="bg-card p-8 rounded-lg shadow-sm border border-border">
        <ArenaLogo className="w-12 mb-8 border mx-auto mb- rounded-[12px] bg-[linear-gradient(137.45deg,rgba(255,255,255,0.12)_9.69%,rgba(153,153,153,0.12)_92.26%)]" />
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-semibold text-foreground">
              Reauthorize Your Store
            </h1>
            <HelpPopover text="Copy this URL and paste it in a new browser tab to reauthorize your store with Shopify." />
          </div>

          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-medium text-foreground mb-2">
                Instructions:
              </h2>
              <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
                <li>Copy the authorization URL below</li>
                <li>Open a new browser tab</li>
                <li>Paste the URL in the address bar and press Enter</li>
                <li>Follow Shopify's authorization process</li>
                <li>
                  Once complete, you'll be redirected back to your dashboard
                </li>
              </ol>
            </div>

            <div>
              <label className="block text-sm font-medium text-muted-foreground mb-2">
                Authorization URL
              </label>
              <CopyCode code={authUrl} prefix="" />
            </div>

            <div className="bg-brand-50 p-4 rounded-lg">
              <p className="text-sm text-brand-600">
                <strong>Note:</strong> This process is necessary to maintain
                secure access to your Shopify store. Your store data and
                settings will remain unchanged.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
